import { useObserver } from "mobx-react";
import { useStores } from "../../../store";
import ScoreCircle from "./ScoreCircle";
import Loader from "../../reusble_components/loader";
import {
  AiOutlineArrowDown,
  AiOutlineCloudUpload,
  AiOutlineExport,
  AiOutlineFilePdf,
} from "react-icons/ai";
import PdfViewer from "../../reusble_components/pdfViewer";
import ReactPaginate from "react-paginate";
import * as XLSX from "xlsx";
import {
  getResumeScoresByJd,
  updateResumeScore,
} from "../../../api/recruiterResumeScoresApi";
import ApplicantLabelPopup from "./applicant_labelPopup";
import { MdBookmark } from "react-icons/md";
import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ExportResumes from "../../reusble_components/ExportResumes";
import { IoMdRefresh } from "react-icons/io";
import CustomButton from "../../reusble_components/buttons/expandingbutton";

export default function ResumeTable(props) {
  const top = useRef(null);
  const { PopupStore, RecuiterStore, CommonStore, LabelStore, UserStore } =
    useStores();
  const [currentPage, setCurrentPage] = useState(0);
  const [pageRefresh, setPageRefresh] = useState(0);
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const save = query.get("save");
  const jdId = location.pathname.split("/").pop();
  const navigate = useNavigate();
  const [uploadmessage, setUploadMessage] = useState("");
  const [ExportResumesPopup, setExportResumesPopup] = useState(false);
  const [isSortingCompleted, setIsSortingCompleted] = useState(false);

  const page = Number(query.get("page")) || 0;
  useEffect(() => {
    console.log("Setting JD ID:", jdId);
    RecuiterStore.setJDID(jdId);
    setCurrentPage(page);
    console.log("Current JD ID in store:", RecuiterStore.jdId);
    console.log("Fetching resume score for page:", page);
    RecuiterStore.fetchResumeScore(page * 10);
    setIsSortingCompleted(
      RecuiterStore.resumeScore?.data?.isSortingCompleted === false &&
        RecuiterStore.resumeScore?.data?.isExtractionCompleted === true
        ? false
        : true,
    );
  }, [page]);

  useEffect(() => {
    const fetchScores = () => {
      console.log("Polling for resume scores...");
      const resumes = RecuiterStore.resumeScore?.data?.resumes || [];
      const hasPendingResumes = resumes.some(
        (resume) =>
          resume.extractionStatus === 0 || resume.extractionStatus === 1,
      );

      if (hasPendingResumes) {
        console.log("Found pending resumes, fetching updates...");
        RecuiterStore.fetchResumeScore(page * 10);
      }
    };

    const intervalId = setInterval(fetchScores, 5000);

    return () => clearInterval(intervalId);
  }, [page]);

  const handlePageClick = (page) => {
    setCurrentPage(page.selected);
    let jdIDFromlocal = localStorage.getItem("jdId");
    console.log("JDID", jdIDFromlocal);
    console.log("JDID", RecuiterStore.jdId || jdIDFromlocal);
    navigate(
      `/company/resumescore/${RecuiterStore.jdId || jdIDFromlocal}?page=${
        page.selected
      }${save ? "&save=true" : ""}`,
    );
    top.current.scrollIntoView({ behavior: "smooth" });
    RecuiterStore.fetchResumeScore(page.selected * 10);
  };
  const exportToExcel = async () => {
    const limit = prompt(
      `Enter the number of resumes you want to export (Max ${RecuiterStore.resumeScore.count})`,
    );
    if (!limit) return;
    let data = [];

    if (RecuiterStore.jdId === "") {
      return;
    }
    RecuiterStore.setLoader(true);
    const response = await getResumeScoresByJd(RecuiterStore.jdId, {
      skip: 0,
      limit,
    });
    RecuiterStore.setLoader(false);
    if (response.status === 200) {
      data = response.body?.data?.resumes.map((applicant) => {
        return {
          Name: applicant?.name,
          Email: applicant?.email,
          Experience: applicant?.experience,
          Score: applicant?.match[0]?.score,
          Suggestion: applicant?.match[0]?.suggestion,
          Resume: applicant?.link,
        };
      });
    } else {
      alert(response.body?.message);
    }
    // this.loader = false;

    const worksheet = XLSX.utils.json_to_sheet(data);

    // Create a new workbook and append the worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Generate Excel file and download
    XLSX.writeFile(workbook, "table_data.xlsx");
  };

  let id = window.location.href.split("/").pop();

  // useEffect(() => {
  //   console.log("ID", id);
  //   if (window.location.href.includes("resumescore")) {
  //     RecuiterStore.fetchResumeScore(0, id, RecuiterStore.resumeScore.count);
  //   }
  // }, []);

  const rowBoxes = [
    {
      width: "20%", // Placeholder for 'Name' in row
      height: "1.2rem",
      shape: "rectangle",
    },
    {
      width: "25%", // Placeholder for 'Email ID' in row
      height: "1.2rem",
      shape: "rectangle",
    },
    {
      width: "15%", // Placeholder for 'Applied Date' in row
      height: "1.2rem",
      shape: "rectangle",
    },
    {
      width: "15%", // Placeholder for 'Applied for' in row
      height: "1.2rem",
      shape: "rectangle",
    },
    {
      width: "10%", // Placeholder for 'Total Score' in row
      height: "1.2rem",
      shape: "rectangle",
    },
    {
      width: "10%", // Placeholder for 'Status' in row
      height: "1.2rem",
      shape: "rectangle",
    },
    {
      width: "10%", // Placeholder for 'Status' in row
      height: "1.2rem",
      shape: "rectangle",
    },
    {
      width: "10%", // Placeholder for 'Status' in row
      height: "1.2rem",
      shape: "rectangle",
    },
  ];

  const [defaultFilter, setDefaultfilter] = useState({
    name: null,
    email: null,
    experience: null,
    score: null,
  });

  const [arraow, setArrow] = useState("");

  const ApplyFilters = (filter) => {
    console.log("Default Filter before", defaultFilter);

    // change default filter to asc or desc
    const newFilter = {
      ...defaultFilter,
      [filter]: defaultFilter[filter] === "asc" ? "desc" : "asc",
    };
    setArrow(defaultFilter[filter]);
    setDefaultfilter(newFilter);

    console.log("Default Filter after", defaultFilter);

    if (
      RecuiterStore.resumeScore?.data?.resumes.length !=
      RecuiterStore.resumeScore.count
    ) {
      RecuiterStore.fetchResumeScore(
        0,
        RecuiterStore.resumeScore?.data?._id,
        RecuiterStore.resumeScore.count,
      );
    }

    RecuiterStore.resumeScore.data.resumes.sort((a, b) => {
      if (filter === "name") {
        if (defaultFilter[filter] === "asc") {
          return a.name?.localeCompare(b.name);
        } else {
          return b.name?.localeCompare(a.name);
        }
      } else if (filter === "email") {
        if (defaultFilter[filter] === "asc") {
          return a.email?.localeCompare(b.email);
        } else {
          return b.email?.localeCompare(a.email);
        }
      } else if (filter === "experience") {
        if (defaultFilter[filter] === "asc") {
          return a.experience - b.experience;
        } else {
          return b.experience - a.experience;
        }
      } else if (filter === "score") {
        if (defaultFilter[filter] === "asc") {
          return a.match[0]?.score - b.match[0]?.score;
        } else {
          return b.match[0]?.score - a.match[0]?.score;
        }
      }
    });

    RecuiterStore.setResumeScore({
      ...RecuiterStore.resumeScore,
      data: {
        ...RecuiterStore.resumeScore.data,
        resumes: RecuiterStore.resumeScore.data.resumes,
      },
    });

    console.log("Resume Score", RecuiterStore.resumeScore);
  };

  const CandidateHireValue = useRef(null);

  return useObserver(() => {
    return (
      <div ref={top} className="w-full mb-32 ">
        {CommonStore.resume && (
          <PdfViewer
            pdfUrl={CommonStore.jobresume}
            onClose={() => CommonStore.setResume(false)}
          />
        )}

        <div
          className={`flex   overflow-hidden  w-full justify-between ${
            props.hide
              ? "w-full items-end justify-end flex "
              : "justify-between"
          }`}
        >
          <p className="font-semibold text-lg text-primary">Resumes</p>

          <div className="flex  items-center gap-4">
            <div className="flex flex-row gap-4  md:hidden">
              {save && !props.sort && (
                <button
                  className="flex items-center gap-2 border bg-primary p-1 text-white px-3 rounded-lg"
                  onClick={props.setSort}
                >
                  Sort now
                </button>
              )}
            </div>
            <CustomButton
              icon={AiOutlineCloudUpload}
              text={"Add Resumes"}
              onClick={() => {
                PopupStore.setAddResumes(true);
              }}
              hoverWidth={true}
            />

            <CustomButton
              icon={IoMdRefresh}
              text="Refresh"
              onClick={() => {
                setCurrentPage(0);
                RecuiterStore.setLoader(true);
                RecuiterStore.setResumeScore([]);
                RecuiterStore.fetchResumeScore(page * 10); // Ensure correct store name
                RecuiterStore.setLoader(false);
              }}
            />

            {/* )} */}
            <CustomButton
              icon={AiOutlineExport}
              text="Export"
              onClick={() => console.log(setExportResumesPopup(true))}
            />
          </div>
        </div>
        {ExportResumesPopup && (
          <ExportResumes
            jdId={jdId}
            onClose={() => setExportResumesPopup(false)}
          />
        )}
        <div
          className="w-full overflow-scroll"
          style={{
            scrollbarWidth: "none",
          }}
        >
          <table className=" relative w-full  mt-3 md:mt-3 lg:mt-4 overflow-scroll bg-white rounded">
            {/* <Loader loader={RecuiterStore.loader} /> */}
            {/* <RecomendPopup app={applicant} /> */}
            <thead className="bg-[#FFE9D9] rounded-2xl h-14 relative">
              {arraow === "asc" ? (
                <AiOutlineArrowDown className="text-lg absolute top-[40%] left-[1%]" />
              ) : arraow === "desc" ? (
                <AiOutlineArrowDown className="text-lg absolute top-[40%] left-[1%] transform rotate-180" />
              ) : null}
              <tr>
                <th
                  className="px-4 py-2 font-medium text-center cursor-pointer"
                  onClick={() => {
                    ApplyFilters("name");
                  }}
                >
                  Name
                </th>
                <th
                  className="px-4 py-2 font-medium text-center cursor-pointer"
                  onClick={() => {
                    ApplyFilters("email");
                  }}
                >
                  Mail
                </th>
                <th
                  className="px-4 py-2 font-medium text-center cursor-pointer"
                  onClick={() => {
                    ApplyFilters("experience");
                  }}
                >
                  Experience
                </th>
                {!save && (
                  <th
                    className="px-4 py-2 font-medium text-center cursor-pointer"
                    onClick={() => {
                      ApplyFilters("score");
                    }}
                  >
                    Score
                  </th>
                )}
                {!save && (
                  <th className="px-4 py-2 font-medium text-center">
                    Suggestion
                  </th>
                )}

                {/* <th className="px-4 py-2 font-medium text-center cursor-pointer">Label</th> */}
                <th className="px-4 py-2 font-medium text-center">Resume</th>
                <th className="px-4 py-2 font-medium text-center">Save</th>
                <th className="px-4 py-2 font-medium text-center">Action</th>
              </tr>
            </thead>
            <tbody>
              {RecuiterStore.resumeScore?.data?.resumes?.length === 0 ||
                (!RecuiterStore.resumeScore?.data?.resumes &&
                  Array.from({ length: 10 }).map((_, index) => (
                    <tr
                      key={index}
                      className="border-b items-center justify-center font-bold text-primary text-xl text-center"
                    >
                      <td colSpan="8" className="py-2">
                        <div
                          className={`bg-gray-100 flex items-center rounded-lg py-3 px-5 shadow-md animate-pulse`}
                          style={{ height: "4rem" }}
                        >
                          <div
                            className={`flex-1 ${
                              true && "" !== "resumescore" ? "ml-4" : ""
                            } flex w-full justify-around`}
                          >
                            {rowBoxes.map((rowBox, idx) => (
                              <div
                                key={idx}
                                className={`bg-gray-300 ${
                                  rowBox.shape === "rectangle"
                                    ? "rounded-md"
                                    : "rounded-full"
                                } mx-2`}
                                style={{
                                  width: rowBox.width,
                                  height: rowBox.height,
                                }}
                              ></div>
                            ))}
                          </div>
                        </div>
                      </td>
                    </tr>
                  )))}
              {RecuiterStore.resumeScore?.data?.resumes?.map(
                (applicant, index) => {
                  if (
                    applicant?.extractionStatus === 1 ||
                    applicant?.extractionStatus === 0
                  ) {
                    return (
                      <tr
                        key={index}
                        className="border-b items-center justify-center font-bold text-primary text-xl text-center"
                      >
                        <td colSpan="8" className="py-2">
                          <div
                            className={`bg-gray-100 flex items-center rounded-lg py-3 px-5 shadow-md animate-pulse`}
                            style={{ height: "4rem" }}
                          >
                            <div
                              className={`flex-1 ${
                                true && "" !== "resumescore" ? "ml-4" : ""
                              } flex w-full justify-around`}
                            >
                              {rowBoxes.map((rowBox, idx) => (
                                <div
                                  key={idx}
                                  className={`bg-gray-300 ${
                                    rowBox.shape === "rectangle"
                                      ? "rounded-md"
                                      : "rounded-full"
                                  } mx-2`}
                                  style={{
                                    width: rowBox.width,
                                    height: rowBox.height,
                                  }}
                                ></div>
                              ))}
                            </div>
                          </div>
                        </td>
                      </tr>
                    );
                  } else if (
                    applicant?.extractionStatus === 4 ||
                    applicant?.extractionStatus === 3
                  ) {
                    return (
                      <tr
                        key={index}
                        className="border-b items-center justify-center text-center hover:bg-gray-50 transition-colors duration-150"
                      >
                        <td
                          colSpan="1"
                          className="py-4 flex items-center gap-2 px-2 md:pl-5 lg:pl-10 justify-center mx-auto"
                        >
                          <div className="w-8 h-8 rounded-full bg-red-50 flex items-center justify-center">
                            <svg
                              className="w-4 h-4 text-red-500"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                              />
                            </svg>
                          </div>
                          <div className="text-gray-900 font-medium">
                            Invalid Resume
                          </div>
                        </td>
                        <td
                          className="py-4 gap-2 px-2 md:pl-5 lg:pl-10 mx-auto"
                          colSpan="1"
                        >
                          <div className="text-sm text-gray-500">
                            Please check the file format
                          </div>
                        </td>
                        <td
                          className="py-4 gap-2 px-2 md:pl-5 lg:pl-10 mx-auto"
                          colSpan="1"
                        >
                          -
                        </td>
                        <td
                          className="py-4 gap-2 px-2 md:pl-5 lg:pl-10 mx-auto"
                          colSpan="1"
                        >
                          -
                        </td>
                        <td
                          className="py-4 gap-2 px-2 md:pl-5 lg:pl-10 mx-auto"
                          colSpan="1"
                        >
                          -
                        </td>
                        <td colSpan="1" className="py-4">
                          <div className="flex items-center justify-center gap-4">
                            <button
                              className="ml-2 px-3 py-1 text-sm text-red-500 hover:text-red-600 hover:bg-red-50 rounded-md transition-colors duration-150 flex items-center gap-1"
                              onClick={() => {
                                CommonStore.setJobResume(applicant?.link);
                                CommonStore.setResume(true);
                              }}
                            >
                              <AiOutlineFilePdf className="text-lg" />
                            </button>
                          </div>
                        </td>
                        <td
                          className="py-4 gap-2 px-2 md:pl-5 lg:pl-10 mx-auto"
                          colSpan="1"
                        >
                          -
                        </td>
                        <td
                          className="py-4 gap-2 px-2 md:pl-5 lg:pl-10 mx-auto"
                          colSpan="1"
                        >
                          -
                        </td>
                      </tr>
                    );
                  } else {
                    return (
                      <tr
                        key={index}
                        className="border-b items-center justify-center text-center"
                      >
                        <td
                          className={`py-2 px-2 md:pl-5 lg:pl-10 ${
                            save && "py-4"
                          }`}
                        >
                          {applicant?.name ?? "-"}
                        </td>
                        <td
                          className={`py-2 px-2 md:pl-4 lg:pl-10 ${
                            save && "py-4"
                          }`}
                        >
                          {applicant?.email ?? "-"}
                        </td>
                        <td
                          className={`py-2 px-2 md:pl-4 lg:pl-10 ${
                            save && "py-4"
                          }`}
                        >
                          {applicant?.experience ?? "0"}
                        </td>
                        {!save && (
                          <td className="px-2 md:pl-4 lg:pl-10">
                            <ScoreCircle score={applicant?.match[0]?.score} />
                          </td>
                        )}
                        {!save && (
                          <td className="py-2 px-2 md:pl-4 lg:pl-10">
                            <div className="flex items-center justify-start w-full">
                              {applicant?.match[0]?.score >= 85 ? (
                                <div className="flex items-center gap-2 px-3 py-1.5 bg-green-50 rounded-full w-[130px]">
                                  <svg
                                    className="w-4 h-4 text-green-500 shrink-0"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                  >
                                    <path
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      strokeWidth="2"
                                      d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                                    />
                                  </svg>
                                  <span className="text-sm font-medium text-green-700 text-left">
                                    {"Best Match"}
                                  </span>
                                </div>
                              ) : applicant?.match[0]?.score >= 75 ? (
                                <div className="flex items-center gap-2 px-3 py-1.5 bg-lime-50 rounded-full w-[130px]">
                                  <svg
                                    className="w-4 h-4 text-lime-500 shrink-0"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                  >
                                    <path
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      strokeWidth="2"
                                      d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                                    />
                                  </svg>
                                  <span className="text-sm font-medium text-lime-700 text-left">
                                    {"Good Fit"}
                                  </span>
                                </div>
                              ) : applicant?.match[0]?.score >= 60 ? (
                                <div className="flex items-center gap-2 px-3 py-1.5 bg-orange-50 rounded-full w-[130px]">
                                  <svg
                                    className="w-4 h-4 text-orange-500 shrink-0"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                  >
                                    <path
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      strokeWidth="2"
                                      d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                    />
                                  </svg>
                                  <span className="text-sm font-medium text-orange-700 text-left">
                                    {"Average Fit"}
                                  </span>
                                </div>
                              ) : applicant?.match[0]?.score >= 50 ? (
                                <div className="flex items-center gap-2 px-3 py-1.5 bg-orange-100 rounded-full w-[130px]">
                                  <svg
                                    className="w-4 h-4 text-orange-700 shrink-0"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                  >
                                    <path
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      strokeWidth="2"
                                      d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                    />
                                  </svg>
                                  <span className="text-sm font-medium text-orange-800 text-left">
                                    {"Fair Fit"}
                                  </span>
                                </div>
                              ) : (
                                <div className="flex items-center gap-2 px-3 py-1.5 bg-red-50 rounded-full w-[130px]">
                                  <svg
                                    className="w-4 h-4 text-red-500 shrink-0"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                  >
                                    <path
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      strokeWidth="2"
                                      d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
                                    />
                                  </svg>
                                  <span className="text-sm font-medium text-red-700 text-left">
                                    {"Not a Fit"}
                                  </span>
                                </div>
                              )}
                            </div>
                          </td>
                        )}

                        <td
                          className={`py-2 px-2 md:pl-4 lg:pl-10 ${
                            save && "py-4"
                          }`}
                        >
                          <span className="flex gap-1 items-center justify-center">
                            <AiOutlineFilePdf
                              className="cursor-pointer"
                              onClick={() => {
                                CommonStore.setJobResume(applicant?.link);
                                CommonStore.setResume(true);
                              }}
                            />
                          </span>
                        </td>
                        <td
                          className={`text-center items-center cursor-pointer ${
                            save && "py-4"
                          }`}
                          onClick={() => {
                            LabelStore.setApplicantId(applicant?._id);
                            LabelStore.setsection("resumeSorting");
                            LabelStore.setApplicantLabelArray(applicant.labels);
                            LabelStore.setApplicants(true);
                          }}
                        >
                          {applicant?.labels.length < 1 ? (
                            <MdBookmark className="mx-auto text-2xl text-gray-300" />
                          ) : (
                            <MdBookmark className="mx-auto text-2xl text-primary" />
                          )}
                        </td>
                        <td className="px-4 py-2 text-center relative group">
                          <select
                            value={applicant.status}
                            className={`appearance-none cursor-pointer w-32 px-3 py-2 rounded-lg border text-sm font-medium focus:outline-none focus:ring-2 focus:ring-opacity-50 transition-all duration-200
                            ${
                              Number(applicant.status) === 0
                                ? "bg-yellow-50 border-yellow-200 text-yellow hover:bg-yellow-100 focus:ring-yellow-200"
                                : Number(applicant.status) === 1
                                  ? "bg-blue-50 border-blue-200 text-blue-500 hover:bg-blue-100 focus:ring-blue-200"
                                  : "bg-red-50 border-red-200 text-red-500 hover:bg-red-100 focus:ring-red-200"
                            }`}
                            onChange={async (e) => {
                              const id = JSON.parse(
                                localStorage.getItem("user"),
                              )._id;
                              const data = {
                                status: Number(e.target.value),
                              };

                              const response = await updateResumeScore(
                                applicant?._id,
                                data,
                              );

                              if (response.status === 200) {
                                setCurrentPage(page);
                                RecuiterStore.setLoader(true);
                                RecuiterStore.setResumeScore([]);
                                RecuiterStore.fetchResumeScore(page * 10);
                                RecuiterStore.setLoader(false);
                              }
                            }}
                          >
                            <option
                              value="0"
                              className="py-2 text-yellow bg-white hover:bg-yellow-50"
                            >
                              Pending
                            </option>
                            <option
                              value="1"
                              className="py-2 text-blue-500 bg-white hover:bg-blue-50"
                            >
                              Shortlist
                            </option>
                            <option
                              value="2"
                              className="py-2 text-red-500 bg-white hover:bg-red-50"
                            >
                              Reject
                            </option>
                          </select>
                        </td>
                        <ApplicantLabelPopup />
                      </tr>
                    );
                  }
                },
              )}
            </tbody>
          </table>
        </div>
        <Loader loader={LabelStore.loader} />
        {RecuiterStore.resumeScore?.data?.resumes.length !=
          RecuiterStore.resumeScore.count && (
          <>
            {RecuiterStore?.resumeScore?.count > 10 && (
              <div>
                <ReactPaginate
                  nextLabel=" >"
                  className="flex justify-center items-center gap-5 my-4"
                  onPageChange={handlePageClick}
                  pageRangeDisplayed={3}
                  marginPagesDisplayed={2}
                  pageCount={RecuiterStore?.resumeScore?.count / 10}
                  previousLabel="< "
                  pageClassName="page-item"
                  pageLinkClassName="page-link"
                  previousClassName="page-item"
                  previousLinkClassName="page-link"
                  nextClassName="page-item"
                  nextLinkClassName="page-link"
                  breakLabel="..."
                  breakClassName="page-item"
                  breakLinkClassName="page-link"
                  containerClassName="pagination"
                  activeClassName="active-page-item"
                  activeLinkClassName="active-page-link"
                  renderOnZeroPageCount={null}
                  forcePage={currentPage}
                />
              </div>
            )}
          </>
        )}
      </div>
    );
  });
}
